import template from "./library-contacts-page.html";

const LibraryContactsPageComponent = {
  template: template,
  controller: class LibraryContactsPageController {
    /* @ngInject */
    constructor($rootScope, Contact, ModalsManager) {
      this.$rootScope = $rootScope;
      this.Contact = Contact;
      this.ModalsManager = ModalsManager;
    }

    async $onInit() {
      this.contacts = [];
      this.searchOptions = { description: "" };
      this.loading = false;

      await this.refreshContacts();
      this.$rootScope.$applyAsync();

      this.$rootScope.$watch(
        () => this.searchOptions.description,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal)) {
            this.searchOptions.description = newVal;
            this.refreshContacts().then();
          }
        },
      );
    }

    async openNewContactForm() {
      const newContact = new this.Contact();
      const contact = await this.ModalsManager.openContactModal(newContact, false);
      if (contact) await this.refreshContacts();
    }

    async refreshContacts() {
      this.loading = true;
      const contactsRetrieved = await this.Contact.query({
        q: this.searchOptions.description || "",
      });
      this.contacts = this._sortContacts(contactsRetrieved);
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    existContacts() {
      return this.contacts.length > 0;
    }

    _sortContacts(contactsRetrieved) {
      const aux = [];
      contactsRetrieved.forEach((contact) => {
        const firstLetter = contact.firstNameCanonical.charAt(0).toLocaleLowerCase();
        if (!aux[firstLetter]) aux[firstLetter] = [];
        aux[firstLetter].push(contact);
      });
      const contactsGroup = [];
      for (const letter in aux) contactsGroup.push({ letter: letter, contacts: aux[letter] });
      contactsGroup.sort((a, b) => {
        if (a.letter > b.letter) return 1;
        if (a.letter < b.letter) return -1;
        return 0;
      });
      return contactsGroup;
    }
  },
};

export default LibraryContactsPageComponent;
